import api, {getUser, logout} from "./index";
import socket from "./socket";
import {identify} from "analytics";
import { notificationPermission } from "my_firebase";
import {userStore} from "./store";
import queryClient from "./query";
 
export async function login(token){
	console.log("LOGIN")
	window.localStorage.setItem(process.env.REACT_APP_KEY, token);
	await init();
	// setGlobalState("loggedIn", true);

}
export async function init(){
	// Consume el login de Vink antes de restaurar la sesión y evaluar las rutas.
	const loginToken = /^\/login\/?$/.test(window.location.pathname)
		? new URLSearchParams(window.location.search).get("token")
		: null;
	if(loginToken){
		window.localStorage.setItem(process.env.REACT_APP_KEY, loginToken);
		window.history.replaceState(window.history.state, "", "/");
	}

	const token = window.localStorage.getItem(process.env.REACT_APP_KEY);
	console.log("init",token, api)
	
	if(token){
		socket.init(token);
		api.init(token);
		notificationPermission();

		try{
			console.log("aaa")
			userStore.set(p => ({...p,status:"loading"}));
			const user = await getUser();
			userStore.set(p => ({user, loggedIn:true, status:"success"}));
		}catch(e){
			console.error({e})
			logout();
			userStore.set(p => ({...p,status:"error", loggedIn:false}));
		}
		
	}
	else{
		socket.disconnect();
		logout();
		userStore.set(p => ({loggedIn:false, status:"success"}));
		
	}
}
export function refresh(key){
	
}



export default {login,init};
